import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuItems`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuItems`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuItems/${id}`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuItems/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menuItems/${id}`, payload);
};

const sameAsUniversal = (merchantId, menuVersionId, buzId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/sameAsUniversal/${menuVersionId}/${buzId}`,
		payload
	);
};

const updateForm = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/menuItems/${id}/pic`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

// 批量新增
const batch = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuItems/batch`, payload);
};

// 批量更新
const batchUpdate = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuItems`, payload);
};

const getItemCode = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuItems/getItemCode`, payload);
};
const diffPrice = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/diffPrice/menuItems`, payload);
};

const diffPriceExport = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/diffPrice/menuItems/export`,
		payload,
		{ responseType: 'blob' },
		{
			headers: {
				'Content-Type': 'application/octet-stream',
			},
		}
	);
};

// 批量调价
const batchPrice = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/batch/menuItems/price`, payload);
};

const channelPrice = (merchantId, branchId, payload) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/channel-price/${merchantId}/${branchId}/channel-price/list`,
		payload
	);
};

const channelPriceExport = (merchantId, branchId, payload) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/channel-price/${merchantId}/${branchId}/channel-price/list/export`,
		payload,
		{ responseType: 'blob' },
		{
			headers: {
				'Content-Type': 'application/octet-stream',
			},
		}
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sameAsUniversal,
	updateForm,
	batch,
	batchUpdate,
	getItemCode,
	diffPrice,
	diffPriceExport,
	batchPrice,
	channelPrice,
	channelPriceExport,
};
